import React, { useState, useMemo } from "react";
import { ArrowBack, Send } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import "./emailTester.scss";

import { API_BASE_URL as API } from "../../config";

function escapeHtml(value = "") {
  return value
    .toString()
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}


const birthdayPreviewSamples = [
  {
    nombre: "Keyla Leiva",
    cargo: "Especialista",
    fechaNacimiento: "1990-05-18",
    documento: "1103499034",
    area: "Gestión Humana",
    profilePicture: "https://i.pravatar.cc/400?img=47",
  },
  {
    nombre: "Juan Pérez",
    cargo: "Coordinador",
    fechaNacimiento: "1988-09-24",
    documento: "1020304050",
    area: "Operaciones",
    profilePicture: "https://i.pravatar.cc/400?img=12",
  },
  {
    nombre: "Laura Gómez",
    cargo: "Analista de Calidad",
    fechaNacimiento: "1992-02-11",
    documento: "123456789",
    area: "Calidad",
    profilePicture: "",
  },
  {
    nombre: "Carlos Rodríguez",
    cargo: "Líder de Equipo",
    fechaNacimiento: "1985-12-03",
    documento: "987654321",
    area: "Liderazgo",
    profilePicture: "https://i.pravatar.cc/400?img=32",
  },
];

function getRandomBirthdayPreviewSample() {
  return birthdayPreviewSamples[Math.floor(Math.random() * birthdayPreviewSamples.length)];
}

function formatBirthdayDate(value = "") {
  if (!value) return "No registrada";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("es-CO", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(date);
}

function buildBirthdayPreviewHTML({ nombre, cargo, fechaNacimiento, documento, area, profilePicture }) {
  const safeName = escapeHtml(nombre || "");
  const safeCargo = escapeHtml(cargo || "");
  const safeBirthday = escapeHtml(formatBirthdayDate(fechaNacimiento));
  const safeDocumento = escapeHtml(documento || "");
  const safeArea = escapeHtml(area || "");
  const initials = escapeHtml((nombre || "U").trim().charAt(0).toUpperCase());
  const avatarSrc = profilePicture && String(profilePicture).trim()
    ? String(profilePicture).trim()
    : '/assets/profileCover/DefaultProfile.jpg';
  const cargoLine = safeCargo ? ` - ${safeCargo}` : "";

  return `
<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <style>
    body { margin: 0; background: #f7f9fc; font-family: 'Segoe UI', Arial, sans-serif; }
    .page { padding: 18px 0 0; }
    .wrap { max-width: 1100px; margin: 0 auto; padding: 0 16px 18px; }
    .year { text-align: right; font-size: 36px; font-weight: 800; letter-spacing: -1px; line-height: 1; color: #19346f; padding: 0 8px 12px; }
    .year span:first-child { color: #49b9f2; }
    .card {
      background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%); border-radius: 28px; overflow: hidden;
      box-shadow: 0 20px 55px rgba(20, 48, 96, 0.10); border: 1px solid rgba(25, 52, 111, 0.08);
    }
    .body { padding: 34px 32px 0; }
    .grid { width: 100%; border-collapse: collapse; }
    .left { width: 58%; vertical-align: top; padding-right: 24px; }
    .right { width: 42%; vertical-align: top; padding-left: 12px; }
    .title {
      font-size: 64px; line-height: 0.95; color: #19346f; font-family: Georgia, 'Times New Roman', serif; font-style: italic;
      font-weight: 700; letter-spacing: -1px; margin: 0;
    }
    .nameRow { margin: 26px 0 18px; display: table; }
    .chevronCell { display: table-cell; vertical-align: middle; }
    .chevron {
      width: 0; height: 0; border-top: 34px solid transparent; border-bottom: 34px solid transparent; border-right: 44px solid #57b9e9;
      filter: drop-shadow(0 4px 10px rgba(87, 185, 233, 0.25));
    }
    .namePill {
      display: table-cell; vertical-align: middle; background: #fff; border-radius: 20px; padding: 14px 22px; box-shadow: 0 4px 18px rgba(15, 52, 111, 0.10);
    }
    .name { color: #1f4d97; font-size: 30px; font-weight: 500; letter-spacing: -0.4px; }
    .cargo { color: #19346f; font-size: 24px; font-weight: 400; }
    .lead, .secondary {
      margin: 0; max-width: 600px; color: #2e3f74; font-size: 28px; line-height: 1.34; font-weight: 400;
    }
    .secondary { margin-top: 18px; max-width: 560px; }
    .accent { margin: 22px 0 0; color: #49b9f2; font-size: 29px; line-height: 1.2; font-weight: 500; }
    .metaGrid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin: 26px 0 0; max-width: 640px; }
    .metaItem { background: #f8fafc; border: 1px solid #e0e8f0; border-radius: 14px; padding: 14px 16px; box-shadow: 0 6px 18px rgba(20, 48, 96, 0.06); }
    .metaLabel { display: block; color: #4f6488; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px; }
    .metaValue { display: block; color: #19346f; font-size: 17px; font-weight: 600; line-height: 1.35; }
    .detail {
      margin: 30px 0 34px; max-width: 440px; background: #fff; border-left: 6px solid #57b9e9; border-radius: 0 14px 14px 0; padding: 16px 20px;
      box-shadow: 0 8px 24px rgba(20, 48, 96, 0.08);
    }
    .detail div { color: #19346f; font-size: 21px; line-height: 1.28; }
    .photoCard {
      position: relative; min-height: 400px; background: #fff; border-radius: 32px; box-shadow: 0 18px 34px rgba(20, 48, 96, 0.10); padding: 20px;
    }
    .dots { position: absolute; top: 20px; right: 18px; color: #19346f; font-size: 28px; line-height: 1; font-weight: 700; letter-spacing: 2px; }
    .photoFrame { min-height: 360px; border-radius: 22px; overflow: hidden; background: linear-gradient(180deg, #f7f7f7 0%, #ececec 100%); position: relative; }
    .photoFrame img { width: 100%; height: 100%; min-height: 360px; object-fit: cover; display: block; }
    .fallback {
      display: none; width: 100%; height: 100%; min-height: 360px; align-items: center; justify-content: center; flex-direction: column;
      background: linear-gradient(135deg, #edf6fb 0%, #dcebf6 100%); color: #19346f; text-align: center;
    }
    .fallback .avatar { width: 128px; height: 128px; border-radius: 50%; background: linear-gradient(135deg, #005fa3 0%, #0077c8 100%); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 54px; font-weight: 800; box-shadow: 0 12px 24px rgba(0, 95, 163, 0.20); }
    .fallback .label { margin-top: 16px; font-size: 18px; font-weight: 700; }
    .footerTop { margin-top: 8px; width: 100%; border-collapse: collapse; }
    .footerTop td { vertical-align: bottom; }
    .footerBar {
      background: linear-gradient(90deg, #5ac1f3 0%, #51b6ea 100%); padding: 16px 30px; text-align: right; margin-top: 0;
    }
    .footerBrand { display: inline-block; color: #17346a; font-size: 28px; font-weight: 800; letter-spacing: -0.6px; }
    .footerNotice { display: inline-block; color: #49b9f2; font-size: 18px; letter-spacing: 2px; }
  </style>
</head>
<body>
  <div class="page">
    <div class="wrap">
      <div class="year"><span>XX</span> JAN</div>
      <div class="card">
        <div class="body">
          <table class="grid" cellpadding="0" cellspacing="0">
            <tr>
              <td class="left">
                <h1 class="title">¡Feliz cumpleaños!</h1>

                <div class="nameRow">
                  <div class="chevronCell"><div class="chevron"></div></div>
                  <div class="namePill"><span class="name">${safeName}</span><span class="cargo">${cargoLine}</span></div>
                </div>

                <p class="lead">Desde <strong>ASSA ABLOY</strong> celebramos tu vida y el impacto positivo que generas cada día con tu talento y compromiso.</p>
                <p class="secondary">Que este nuevo año venga lleno de bienestar, aprendizajes y nuevos logros.</p>
                <p class="accent">¡Que lo disfrutes!</p>

                <div class="metaGrid">
                  <div class="metaItem"><span class="metaLabel">Cargo</span><span class="metaValue">${safeCargo || "No registrado"}</span></div>
                  <div class="metaItem"><span class="metaLabel">Fecha de cumpleaños</span><span class="metaValue">${safeBirthday}</span></div>
                  <div class="metaItem"><span class="metaLabel">Documento</span><span class="metaValue">${safeDocumento || "No registrado"}</span></div>
                  <div class="metaItem"><span class="metaLabel">Área</span><span class="metaValue">${safeArea || "No registrada"}</span></div>
                </div>

                <div class="detail">
                  <div>Acércate a Recursos Humanos,</div>
                  <div>tenemos un detalle preparado para ti.</div>
                </div>
              </td>
              <td class="right">
                <div class="photoCard">
                  <div class="dots">⋮</div>
                  <div class="photoFrame">
                    <img src="${avatarSrc}" alt="${safeName}" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" />
                    <div class="fallback">
                      <div class="avatar">${initials}</div>
                      <div class="label">${safeName}${safeCargo ? ` - ${safeCargo}` : ""}</div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </table>

          <table class="footerTop" cellpadding="0" cellspacing="0">
            <tr>
              <td style="width: 58%; padding-right: 24px;">
                <div class="detail" style="margin: 0 0 10px; max-width: 460px;">
                  <div style="font-size: 16px;">Acércate a Recursos Humanos, tenemos un detalle preparado para ti.</div>
                </div>
              </td>
              <td style="width: 42%; text-align: right; padding-bottom: 8px;">
                <div class="footerNotice">•••••</div>
              </td>
            </tr>
          </table>
        </div>
        <div class="footerBar"><span class="footerBrand">ASSA ABLOY</span></div>
      </div>
    </div>
  </div>
</body>
</html>`;
}

export default function EmailTester() {
  const navigate = useNavigate();
  const [templateType, setTemplateType] = useState("welcome");
  const [recipientEmail, setRecipientEmail] = useState("mijail.serrano@assaabloy.com");
  const [testData, setTestData] = useState({
    nombre: "Juan Pérez",
    usuario: "jperez",
    password: "123456",
    cargo: "Especialista",
    profilePicture: "",
    fechaNacimiento: "1990-01-01",
    documento: "1103499034",
    email: "mijail.serrano@assaabloy.com",
    area: "General",
    years: 5,
    mentionedBy: "Carlos Rodríguez",
    spaceName: "General",
    postTitle: "Actualización del Espacio",
    postContent: "Se publicó una actualización importante para el equipo del espacio.",
    postImage: ""
  });
  const [birthdayPreviewUser, setBirthdayPreviewUser] = useState(() => getRandomBirthdayPreviewSample());
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState("success");

  const templateLabels = {
    welcome: "Bienvenida",
    birthday_file: "Cumpleaños (plantilla actual)",
    anniversary: "Aniversario",
    mention: "Mención",
    publication: "Publicación"
  };

  const handleSendTest = async () => {
    if (!recipientEmail.trim()) {
      setMessageType("error");
      setMessage("Por favor ingresa un email de prueba");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API}/api/email/test-send`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token") || ""}` },
        body: JSON.stringify({
          templateType,
          recipientEmail,
          testData
        })
      });

      const result = await res.json();

      if (res.ok) {
        setMessageType("success");
        setMessage(`Correo de prueba (${templateLabels[templateType] || templateType}) enviado a ${recipientEmail}`);
      } else {
        setMessageType("error");
        setMessage(`Error: ${result.message}`);
      }
    } catch (error) {
      setMessageType("error");
      setMessage(`Error en la solicitud: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleTestDataChange = (field, value) => {
    setTestData({
      ...testData,
      [field]: field === "years" ? parseInt(value) || 1 : value
    });
  };

  const birthdayPreviewHtml = useMemo(() => {
    if (templateType === "birthday" || templateType === "birthday_file") {
      return buildBirthdayPreviewHTML({
        nombre: testData.nombre,
        cargo: testData.cargo,
        fechaNacimiento: testData.fechaNacimiento,
        documento: testData.documento,
        area: testData.area,
        profilePicture: testData.profilePicture,
      });
    }
    return "";
  }, [templateType, testData.nombre, testData.cargo, testData.fechaNacimiento, testData.documento, testData.area, testData.profilePicture]);

  return (
    <div className="email-tester-container">
      <div className="email-tester-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <ArrowBack style={{ marginRight: "8px" }} />
          Volver
        </button>
        <h1>Prueba de Correos</h1>
        <p className="subtitle">Envía correos de prueba a cualquier dirección</p>
      </div>

      <div className="email-tester-content">
        {/* Sección de configuración */}
        <div className="config-section">
          <h2>Configuración de Prueba</h2>

          {/* Seleccionar plantilla */}
          <div className="form-group">
            <label>Tipo de Plantilla</label>
            <div className="template-buttons">
              <button
                className={`template-btn ${templateType === "welcome" ? "active" : ""}`}
                onClick={() => setTemplateType("welcome")}
              >
                Bienvenida
              </button>
              <button
                className={`template-btn ${templateType === "birthday_file" ? "active" : ""}`}
                onClick={() => setTemplateType("birthday_file")}
              >
                Cumpleaños
              </button>
              <button
                className={`template-btn ${templateType === "anniversary" ? "active" : ""}`}
                onClick={() => setTemplateType("anniversary")}
              >
                Aniversario
              </button>
              <button
                className={`template-btn ${templateType === "mention" ? "active" : ""}`}
                onClick={() => setTemplateType("mention")}
              >
                Mención
              </button>
              <button
                className={`template-btn ${templateType === "publication" ? "active" : ""}`}
                onClick={() => setTemplateType("publication")}
              >
                Publicación
              </button>
            </div>
          </div>

          {/* Email de prueba */}
          <div className="form-group">
            <label>Email de Prueba</label>
            <input
              type="email"
              value={recipientEmail}
              onChange={(e) => setRecipientEmail(e.target.value)}
              placeholder="ejemplo@assaabloy.com"
            />
          </div>

          {/* Datos de prueba */}
          <div className="form-group">
            <label>Datos de Prueba</label>
            <div className="test-data-grid">
              <div>
                <label>Nombre</label>
                <input
                  type="text"
                  value={testData.nombre}
                  onChange={(e) => handleTestDataChange("nombre", e.target.value)}
                />
              </div>
              <div>
                <label>Usuario</label>
                <input
                  type="text"
                  value={testData.usuario}
                  onChange={(e) => handleTestDataChange("usuario", e.target.value)}
                />
              </div>
              <div>
                <label>Contraseña</label>
                <input
                  type="text"
                  value={testData.password}
                  onChange={(e) => handleTestDataChange("password", e.target.value)}
                />
              </div>
              <div>
                <label>Cargo</label>
                <input
                  type="text"
                  value={testData.cargo}
                  onChange={(e) => handleTestDataChange("cargo", e.target.value)}
                />
              </div>
              {(templateType === "birthday" || templateType === "birthday_file") && (
                <div>
                  <label>Foto de perfil (URL)</label>
                  <input
                    type="text"
                    value={testData.profilePicture}
                    onChange={(e) => handleTestDataChange("profilePicture", e.target.value)}
                    placeholder="/assets/profile/foto.jpg o https://..."
                  />
                </div>
              )}
              {(templateType === "birthday" || templateType === "birthday_file") && (
                <>
                  <div>
                    <label>Fecha de cumpleaños</label>
                    <input
                      type="date"
                      value={testData.fechaNacimiento}
                      onChange={(e) => handleTestDataChange("fechaNacimiento", e.target.value)}
                    />
                  </div>
                  <div>
                    <label>Documento</label>
                    <input
                      type="text"
                      value={testData.documento}
                      onChange={(e) => handleTestDataChange("documento", e.target.value)}
                    />
                  </div>
                  <div>
                    <label>Área</label>
                    <input
                      type="text"
                      value={testData.area}
                      onChange={(e) => handleTestDataChange("area", e.target.value)}
                    />
                  </div>
                </>
              )}
              {(templateType === "birthday" || templateType === "birthday_file" || templateType === "anniversary") && (
                <div>
                  <label>Años {(templateType === "birthday" || templateType === "birthday_file") ? "(ignorado)" : ""}</label>
                  <input
                    type="number"
                    min="1"
                    value={testData.years}
                    onChange={(e) => handleTestDataChange("years", e.target.value)}
                  />
                </div>
              )}
              {templateType === "mention" && (
                <>
                  <div>
                    <label>Mencionado por</label>
                    <input
                      type="text"
                      value={testData.mentionedBy}
                      onChange={(e) => handleTestDataChange("mentionedBy", e.target.value)}
                      placeholder="Carlos Rodríguez"
                    />
                  </div>
                  <div>
                    <label>Nombre del Espacio</label>
                    <input
                      type="text"
                      value={testData.spaceName}
                      onChange={(e) => handleTestDataChange("spaceName", e.target.value)}
                      placeholder="General"
                    />
                  </div>
                </>
              )}
              {templateType === "publication" && (
                <>
                  <div>
                    <label>Autor de la publicación</label>
                    <input
                      type="text"
                      value={testData.mentionedBy}
                      onChange={(e) => handleTestDataChange("mentionedBy", e.target.value)}
                      placeholder="Carlos Rodríguez"
                    />
                  </div>
                  <div>
                    <label>Espacio</label>
                    <input
                      type="text"
                      value={testData.spaceName}
                      onChange={(e) => handleTestDataChange("spaceName", e.target.value)}
                      placeholder="General"
                    />
                  </div>
                  <div>
                    <label>Título de la publicación</label>
                    <input
                      type="text"
                      value={testData.postTitle}
                      onChange={(e) => handleTestDataChange("postTitle", e.target.value)}
                      placeholder="Actualización del Espacio"
                    />
                  </div>
                  <div>
                    <label>Contenido</label>
                    <input
                      type="text"
                      value={testData.postContent}
                      onChange={(e) => handleTestDataChange("postContent", e.target.value)}
                      placeholder="Detalle de la publicación"
                    />
                  </div>
                  <div>
                    <label>URL de imagen (opcional)</label>
                    <input
                      type="text"
                      value={testData.postImage}
                      onChange={(e) => handleTestDataChange("postImage", e.target.value)}
                      placeholder="https://.../imagen.jpg"
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Botón de envío */}
          <button
            className="send-button"
            onClick={handleSendTest}
            disabled={loading}
          >
            <Send style={{ marginRight: "8px" }} />
            {loading ? "Enviando..." : `Enviar Correo de Prueba (${templateLabels[templateType] || templateType})`}
          </button>
        </div>

        {/* Mensaje de resultado */}
        {message && (
          <div className={`message ${messageType}`}>
            {message}
            <button
              className="close-message"
              onClick={() => setMessage(null)}
            >
              ✕
            </button>
          </div>
        )}

        {/* Información */}
        <div className="info-section">
          <h3>Información de Prueba</h3>
          <ul>
            <li><strong>Bienvenida:</strong> Correo con credenciales de acceso</li>
            <li><strong>Cumpleaños:</strong> Correo de felicitación personalizado</li>
            <li><strong>Aniversario:</strong> Correo celebrando años en la empresa</li>
            <li><strong>Cambio de Contraseña:</strong> Recordatorio de seguridad cada 90 días</li>
            <li><strong>Mención:</strong> Notificación cuando alguien te menciona (@usuario) en una publicación</li>
            <li><strong>Publicación:</strong> Notificación automática cuando se publica en un espacio</li>
          </ul>
          <p style={{ marginTop: "20px", color: "#666" }}>
            Los correos de prueba incluyen la marca "CORREO DE PRUEBA" en el asunto.
          </p>
        </div>

        {/* Preview removed: test emails are generated by the backend using the real template */}
      </div>
    </div>
  );
}
